import ModelFactory from './ModelFactory';
import {registerModels, registerModel} from './registerModels';

export {
    ModelFactory,
    registerModel,
    registerModels,
}